<template>
  <b-card>
    <validation-observer v-slot="{ invalid }">
      <!-- form -->
      <b-form>
        <b-row>
          <!-- buttons -->
          <b-col cols="12">
            <FormField
              :entity="subscriber"
              :form-field="field"
              module=""
            />
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              :disabled="invalid"
              @click.prevent="submitForm"
            >
              {{ $t('Save Changes') }}
            </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { BButton, BForm, BRow, BCol, BCard } from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import FormField from '@/layouts/entity/FormField.vue'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'

export default {
  components: {
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    ValidationObserver,
    FormField,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      subscriber: {},
      entity: JSON.parse(JSON.stringify(this.userData)),
      lists: [],
    }
  },
  computed: {
    field() {
      return {
        id: 'lists',
        type: 'checkboxgroup',
        label: this.$t('Lists'),
        labelField: 'name',
        options: this.lists,
        stacked: true,
      }
    },
    nsApiUrl() {
      return 'https://www.hcs.gr/wp-json/newsletter/v2/'
    },
    subscriberUrl() {
      return `${this.nsApiUrl}subscribers/${this.entity.participant.email}`
    },
    authHeaders() {
      const username = 'efeec8d1b194b5dfca58ac09351bfa0fb228a8b4';
      const password = '8412b28c7ff238f5768a55c1e9582518b9f55f3e';
      const token = btoa(`${username}:${password}`)
      return {
        headers: {
          'Authorization': `Basic ${token}`,
          'Content-Type': 'application/json'
        }
      }
    },
  },
  async mounted() {
    this.lists = (await axios.get(`${this.nsApiUrl}lists`, this.authHeaders)).data.filter(list => list.id > 30)
    this.subscriber = (await axios.get(this.subscriberUrl, this.authHeaders)).data
    if (!this.subscriber.id) {
      this.subscriber = {
        email: this.entity.participant.email,
        first_name: this.entity.participant.firstName,
        last_name: this.entity.participant.lastName,
        status: 'confirmed',
        lists: [],
      }
    } else {
      this.subscriber.lists = this.subscriber.lists.map(list => list.id)
    }
  },
  methods: {
    submitForm() {
      const payload = { ...this.subscriber }
      if (this.subscriber.lists.length > 0) {
        const allists = this.lists.map(list => list.id)
        payload.lists = []
        allists.forEach(item => {
          payload.lists.push({ id: item, value: this.subscriber.lists.includes(item) ? 1 : 0 })
        })
      }
      return axios
        .put(this.subscriberUrl, payload, this.authHeaders)
        .then(() => {
          this.showToast({
            title: this.$t('Entity Saved'),
            icon: 'EditIcon',
            variant: 'success',
            text: this.$t('Save completed successfully'),
          })
        })
        .catch(() => {
          this.showToast({
            title: this.$t('Something went wrong!'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          })
        })
    },
  },
}
</script>
